import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { BasePathProvider } from './context/BasePathContext'
import { FavoritesProvider, useFavoritesContext } from '../shared/FavoritesContext'
import Explorer from './components/Explorer'
import PairingsIndex from './components/PairingsIndex'
import PairingCategory from './components/PairingCategory'
import ToolNav from '../shared/ToolNav'

function AppContent() {
  const { isFontFavorited, isFontSortFavorited, toggleFont, isPairingFavorited, togglePairing, authenticated } = useFavoritesContext()

  return (
    <>
      <ToolNav current="/google-font-explorer" />
      <Routes>
        <Route path="/google-font-explorer" element={
          <Explorer
            isFontFavorited={isFontFavorited}
            isFontSortFavorited={isFontSortFavorited}
            toggleFont={toggleFont}
            authenticated={authenticated}
          />
        } />
        <Route path="/google-font-explorer/pairings" element={
          <BasePathProvider value="/google-font-explorer/pairings">
            <PairingsIndex />
          </BasePathProvider>
        } />
        <Route path="/google-font-explorer/pairings/:categoryId" element={
          <BasePathProvider value="/google-font-explorer/pairings">
            <PairingCategory
              isPairingFavorited={isPairingFavorited}
              togglePairing={togglePairing}
              authenticated={authenticated}
            />
          </BasePathProvider>
        } />
        <Route path="*" element={<Navigate to="/google-font-explorer" replace />} />
      </Routes>
    </>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <FavoritesProvider rootElementId="font-explorer">
        <AppContent />
      </FavoritesProvider>
    </BrowserRouter>
  )
}
